module.exports = __webpack_public_path__ + "static/media/glossy-pc-monitor.4fd94cc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/glossy-pc-monitor.svg
// module id = 650
// module chunks = 1